module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div\n  class="ngeo-googlestreetview-instructions"\n  ng-if="$ctrl.location === null"\n  translate>\n  Click on a road on the map to start StreetView.\n</div>\n<div\n  class="ngeo-googlestreetview-nodata"\n  ng-if="$ctrl.noDataAtLocation"\n  translate>\n  Street View data not found for this location.\n</div>\n';

}
return __p
}